import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import swal from 'sweetalert2';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';
import { ReservationService } from '../../services/reservation-service/reservation.service';

@Component({
  selector: 'app-add-customer-dialog',
  templateUrl: './add-customer-dialog.component.html',
  styleUrls: ['./add-customer-dialog.component.css']
})
export class AddCustomerDialogComponent implements OnInit {
  addCustomerForm = {
    lead_id: '',
    lead_name: '',
    lead_phone: '',
    lead_home_phone: '',
    lead_other_phone: '',
    lead_email: '',
    lead_national_id: '',
    lead_nationality: '',
    lead_birthday: '',
    lead_address: '',
    lead_district: '',
    phone_without_code: '',
    code: '',
    phone_2_without_code: '',
    code_2: '',
    phone_3_without_code: '',
    code_3: '',
    sharing_percentage: null,
    customer_type: null,
    phone_error: '',
    other_phone_error: ''
  };

  customerTypes = [
    { label: 'New', value: 'New' },
    { label: 'Transfered', value: 'Transfered' }
  ];

  chosenCustomer: string = '';
  arrSearch: any[];
  customersData: any;
  reservationId: any;

  constructor(
    public dialogRef: MatDialogRef<AddCustomerDialogComponent>,
    private http: HttpClient,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.reservationId = data.reservation_id;
  }

  ngOnInit() {
    // Initialize form if needed
  }


  customerSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}&without_freezed=${true}`)
        .map((res: any) => {
          if (res.data.length == 0) {
            const arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.customersData = res.data;
            res.data.forEach((e) => {
              this.arrSearch.push(`${e.name} / ${e.id}`);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };
  getCustomerDetails() {
    console.log("chooosen", this.customersData);

    if (!this.chosenCustomer) {
      swal("Lead name can not be empty!");
    } else {
      if (this.customersData.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        this.customersData.forEach((element) => {
          const leadId = this.chosenCustomer.replace(/\s/g, "").split("/")[1];
          if (element.id == leadId) {
            this.addCustomerForm.lead_id = element.id;
            found = true;

            this.addCustomerForm.lead_name = element.name;
            this.addCustomerForm.lead_phone = element.phone;
            this.addCustomerForm.lead_email = element.email;
            this.addCustomerForm.lead_national_id = element.national_num;
            this.addCustomerForm.lead_nationality = element.national_num;
            this.addCustomerForm.lead_other_phone = element.phone_2;
            this.addCustomerForm.lead_birthday = element.date_of_birth;
            this.addCustomerForm.lead_address = element.address;
            this.addCustomerForm.lead_district = element.location;
            this.addCustomerForm.phone_without_code = element.phone_without_code;
            this.addCustomerForm.code = element.code;
            this.addCustomerForm.phone_3_without_code = element.phone_3_without_code;
            this.addCustomerForm.code_3 = element.code_3;
            this.addCustomerForm.phone_2_without_code = element.phone_2_without_code;
            this.addCustomerForm.code_2 = element.code_2;
            this.addCustomerForm.sharing_percentage =
              element.sharing_percentage;
            this.addCustomerForm.customer_type = null;
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  getCustomerInfo() {
    if (!this.chosenCustomer) return;

    if (this.data.customersData) {
      let found = false;
      this.data.customersData.forEach((element) => {
        const leadId = this.chosenCustomer.replace(/\s/g, "").split("/")[1];
        if (element.id == leadId) {
          this.addCustomerForm.lead_id = element.id;
          found = true;

          this.addCustomerForm.lead_name = element.name;
          this.addCustomerForm.lead_phone = element.phone;
          this.addCustomerForm.lead_email = element.email;
          this.addCustomerForm.lead_national_id = element.national_num;
          this.addCustomerForm.lead_nationality = element.national_num;
          this.addCustomerForm.lead_other_phone = element.phone_2;
          this.addCustomerForm.lead_birthday = element.date_of_birth;
          this.addCustomerForm.lead_address = element.address;
          this.addCustomerForm.lead_district = element.location;
          this.addCustomerForm.phone_without_code = element.phone_without_code;
          this.addCustomerForm.code = element.code;
          this.addCustomerForm.phone_3_without_code = element.phone_3_without_code;
          this.addCustomerForm.code_3 = element.code_3;
          this.addCustomerForm.phone_2_without_code = element.phone_2_without_code;
          this.addCustomerForm.code_2 = element.code_2;
          this.addCustomerForm.sharing_percentage = element.sharing_percentage;
          this.addCustomerForm.customer_type = null;
        }
      });
    }
  }

  receivePhone(event: any, phoneField: string, codeField: string, errorField: string) {
    this.addCustomerForm[phoneField] = event.phone;
    this.addCustomerForm[codeField] = event.code;
    this.addCustomerForm[errorField] = event.phoneError;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

    submitAddCustomer() {
      // Validation
      if (this.addCustomerForm.phone_error) {
        swal("Invalid Primary Phone", this.addCustomerForm.phone_error || "Please enter a valid phone number", "error");
        return;
      }
      if (this.addCustomerForm.other_phone_error) {
        swal("Invalid Third Phone", this.addCustomerForm.other_phone_error || "Please enter a valid phone number", "error");
        return;
      }
      if (!this.addCustomerForm.lead_id) {
        swal("Lead ID can not be empty", "Click on get info button to get the lead.", "error");
        return;
      }
      if (!this.addCustomerForm.lead_name) {
        swal("Client Name can not be empty", "", "error");
        return;
      }
      if (!this.addCustomerForm.lead_phone) {
        swal("Client Phone can not be empty", "", "error");
        return;
      }
  
      // Call the backend endpoint
      this.reservationService
        .addLead(this.reservationId, this.addCustomerForm)
        .subscribe(
          (res) => {
            swal("Customer added successfully", "", "success");
            // Return the form data to the parent component
            this.dialogRef.close(this.addCustomerForm);
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          },
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/dialogs/add-customer-dialog/add-customer-dialog.component.ts